{
  "clear": "Καθαρισμός",
  "invalid": "(δεν ισχύει)",
  "loading": "Φόρτωση...",
  "noResults": "Χωρίς αποτέλεσμα"
}
